import { render, staticRenderFns } from "./taskSet.vue?vue&type=template&id=9819163c&scoped=true&"
import script from "./taskSet.vue?vue&type=script&lang=js&"
export * from "./taskSet.vue?vue&type=script&lang=js&"
import style0 from "./taskSet.vue?vue&type=style&index=0&id=9819163c&prod&lang=scss&scoped=true&"
import style1 from "./taskSet.vue?vue&type=style&index=1&id=9819163c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9819163c",
  null
  
)

export default component.exports